import React from "react"
import DealerRewardListTableComponent from "./dealerRewardListTable.component"

export default function DealerRewardListTableContainer({
  hasStockflowRewardCenterViewAccessRight,
  rows,
  isFetching,
  isError,
  handleReload,
  page,
  rowsPerPage,
  handleChangePage,
  language,
  handleChangeRowsPerPage,
  isSearchResult,
  totalFiltered,
  paginationOptions,
  tableFilter,
  changeOrder,
  lang,
  handleViewDetail
}) {
  return (
    <DealerRewardListTableComponent
      hasStockflowRewardCenterViewAccessRight={hasStockflowRewardCenterViewAccessRight}
      rows={rows}
      isFetching={isFetching}
      isError={isError}
      handleReload={handleReload}
      language={language}
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangePage={handleChangePage}
      handleChangeRowPerPage={handleChangeRowsPerPage}
      isSearchResult={isSearchResult}
      totalFiltered={totalFiltered}
      paginationOptions={paginationOptions}
      tableFilter={tableFilter}
      changeOrder={changeOrder}
      lang={lang}
      handleViewDetail={handleViewDetail}
    />
  )
}